import React from "react";
import axios from "axios";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import CustomToolbar from "../../global/CustomToolbar";
import { BACK_TO_MENU_TITLE } from "../ManageCompany/constants";

import TableCell from "@material-ui/core/TableCell";
import { Tooltip } from "@mui/material";
import {IconButton} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

import TablePage from "../../global/Table/TablePage";
import SearchableTable from "../../global/Search/SearchableTable";
import withShipment from "../../../withShipment";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {BASE_URL} from "../../global/Server/endpoints";
import TwoStepDelete from "../../global/subcomponents/twoStepDelete/TwoStepDelete";

class ManageFolder extends SearchableTable {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            addingFolder: false,
            folderId: null,
            title: "",
            role: "",
            imageFile: null,
            imagePreview: null,
            dashboardCards: [],
        };
    }

    /* ==============================================
       FETCH FOLDERS
    ============================================== */
    async componentDidMount() {
        this.fetchDashboardFolders();
    }

    fetchDashboardFolders = async () => {
        try {
            const token = localStorage.getItem("token");


            const res = await axios.post(
                `${BASE_URL}/dashboardFolder/list`,
                { companyId: this.props.userInfo.company},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.success) {
                this.setState({ dashboardCards: res.data.data });
            } else {
                this.openFeedback("error", res.data.message || "Failed to load folders");
            }
        } catch (e) {
            console.error("Fetch error:", e);
            this.openFeedback("error", "Server error while fetching folders");
        }
    };

    /* ==============================================
       FORM HANDLERS
    ============================================== */
    handleTitleChange = (e) => {
        const val = e.target.value;
        this.setState({
            title: val,
            role: val.toLowerCase().replace(/ /g, "-"),
        });
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        this.setState({
            imageFile: file,
            imagePreview: URL.createObjectURL(file),
        });
    };

    fileToByteArray = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];
                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                resolve(byteNumbers);
            };

            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    /* ==============================================
       SAVE FOLDER
    ============================================== */
    saveCard = async () => {
        try {
            const token = localStorage.getItem("token");

            let payload = {
                dashboardFolderId: this.state.folderId, // for update
                companyId: this.props.userInfo.company,
                title: this.state.title,
                role: this.state.role,
            };

            // Only upload new image if user selected one
            if (this.state.imageFile) {
                const imageBytes = await this.fileToByteArray(this.state.imageFile);
                const imageName = this.state.imageFile.name;
                payload.imageFile = imageBytes;
                payload.imageName = imageName;
            }

            const res = await axios.post(`${BASE_URL}/dashboardFolder/save`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!res.data.success) {
                this.openFeedback("error", res.data.message);
                return;
            }

            // refresh table
            await this.fetchDashboardFolders();


            this.openFeedback("success", this.state.folderId ? "Folder updated successfully!" : "Folder created successfully!");


            this.setState({
                addingFolder: false,
                folderId: null,
                title: "",
                role: "",
                imageFile: null,
                imagePreview: null,
            });

        } catch (e) {
            console.error("Save error:", e);
            this.openFeedback("error", "Server error while saving folder.");
        }
    };


    /* ==============================================
       EDIT FOLDER
    ============================================== */
    editFolder = (folder) => {
        this.setState({
            addingFolder: true,
            folderId: folder.dashboardFolderId,
            title: folder.title,
            role: folder.role,
            imageFile: null, // user can upload a new image
            imagePreview: folder.imageUrl || null,
        });
    };

    /* ==============================================
       FEEDBACK HELPERS
    ============================================== */
    openFeedback = (severity, message) => {
        this.setState({
            feedbackBarOpen: true,
            feedbackStatus: severity,
            feedbackMessage: message,
        });
    };

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false });
    };

    /* ==============================================
       BACK
    ============================================== */
    cancelFolder = () => {
        this.setState({
            addingFolder: false,
            title: "",
            role: "",
            imageFile: null,
            imagePreview: null,
        });
    };

    /* ==============================================
       TABLE HEADERS
    ============================================== */
    getTableHeaders() {
        return [ "Title", "Image",""];
    }

    /* ==============================================
       RENDER
    ============================================== */
    render() {
        const headerButtons = !this.state.addingFolder
            ? [
                {
                    icon: <AddCircleIcon />,
                    handler: () => this.setState({ addingFolder: true, folderId:null }),
                    title: "Create Folder",
                },
            ]
            : [
                {
                    icon: <KeyboardBackspaceIcon />,
                    handler: this.cancelFolder,
                    title: "Back",
                },
            ];

        return (
            <>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />

                <ErrorFeedbackBar />

                <CustomToolbar
                    title="Manage Folder"
                    backTitle={BACK_TO_MENU_TITLE}
                    headerButtons={headerButtons}
                />

                {/* ----------------------- CREATE FORM ----------------------- */}
                {this.state.addingFolder && (
                    <div style={{ maxWidth: 500, margin: "auto", padding: 20 }}>
                        <h2>Create Folder</h2>

                        <label>Title</label>
                        <input
                            type="text"
                            value={this.state.title}
                            onChange={this.handleTitleChange}
                            className="form-control"
                        />

                        <label>Role (auto)</label>
                        <input type="text" value={this.state.role} readOnly className="form-control" />

                        <label>Image</label>
                        <input type="file" accept="image/*" onChange={this.handleImageChange} className="form-control"/>

                        {this.state.imagePreview && (
                            <img
                                src={this.state.imagePreview}
                                style={{ width: "100%", marginTop: 10, borderRadius: 8 }}
                                alt=""
                            />
                        )}

                        <button onClick={this.saveCard} className="btn btn-primary mt-3">
                            Save Folder
                        </button>
                    </div>
                )}

                {/* ----------------------- TABLE ----------------------- */}
                {!this.state.addingFolder && (
                    <TablePage
                        tableName="folderTable"
                        tableRows={this.state.dashboardCards}
                        tableColumnHeads={this.getTableHeaders()}
                        tableRow={(row) => (
                            <>
                                <TableCell style={{ textAlign: "center" }}>
                                    {row.title}
                                </TableCell>

                                <TableCell style={{ textAlign: "center" }}>
                                    {row.imageUrl ? (
                                        <img
                                            src={row.imageUrl}
                                            style={{
                                                objectFit: "cover",
                                                borderRadius: 6,
                                                width: 200,
                                                height: 200,
                                            }}
                                            alt=""
                                        />
                                    ) : (
                                        "No Image"
                                    )}
                                </TableCell>

                                <TableCell style={{ display: "flex", justifyContent: "center", height: 240 }}>
                                    <Tooltip title="Edit">
                                        <IconButton onClick={() => this.editFolder(row)}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <TwoStepDelete
                                        rowId={row.dashboardFolderId}
                                        handleDelete={async (rowIdToDelete) => {
                                            try {
                                                const token = localStorage.getItem("token");
                                                const res =await axios.post(`${BASE_URL}/dashboardFolder/delete`,
                                                    { dashboardFolderId: rowIdToDelete},
                                                    {
                                                        headers: {
                                                            Authorization: `Bearer ${token}`,
                                                            "Content-Type": "application/json",
                                                        },
                                                    }
                                                );
                                                if (res.data.success) {
                                                    this.setState({
                                                        dashboardCards: this.state.dashboardCards.filter(f => f.dashboardFolderId !== rowIdToDelete)
                                                    });
                                                }else{
                                                    this.openFeedback("error", res.data.message);
                                                }


                                            } catch (err) {
                                                this.openFeedback("error", err);
                                            }
                                        }}
                                        deleteId={this.state.deleteId}
                                        setDeleteId={(newDeleteId) => this.setState({ deleteId: newDeleteId })}
                                    />
                                </TableCell>
                            </>
                        )}
                    />
                )}
            </>
        );
    }
}


const mapStateToProps = (state) => ({
    userInfo: userInfoSelector(state),
})

export default withShipment({
    mapStateToProps,
}, ManageFolder);
